import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationService } from 'core/http/lg-logistic-rest-api/Auth/registration.service';
import { asyncTrue } from 'core/utils/async-validators';
import { Observable } from 'rxjs';
import { ObserverFactory } from 'shared/common/observers';
import { compare, CriteriaParams } from 'shared/criteria/Criteria';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RegistrationComponent {
  private readonly params = this.route.snapshot.params as {
    token: string;
  };

  private _form: UntypedFormGroup = createForm((c: CriteriaParams) => this.registrationService.hasUser(c));

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private registrationService: RegistrationService,
    private observers: ObserverFactory,
  ) {}

  get registryForm(): UntypedFormGroup {
    return this._form;
  }

  register(form: UntypedFormGroup): void {
    if (form.invalid) {
      return;
    }

    this.registrationService
      .registration({ ...this.registryForm.value, inviteId: this.params.token })
      .subscribe(
        this.observers.withHook({
          onSuccess: () => this.router.navigate(['/']),
          successMsg: 'NOTIFICATIONS.registration_success',
        }),
      );
  }
}

function createForm(userChecker: (c: CriteriaParams) => Observable<boolean>): UntypedFormGroup {
  return new UntypedFormGroup({
    login: new UntypedFormControl(
      null,
      Validators.compose([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(255),
      ]),
      asyncTrue((current: string) => userChecker({ filter: compare.eq('login', current) })),
    ),
    email: new UntypedFormControl(
      null,
      Validators.compose([
        Validators.required,
        Validators.email,
        Validators.maxLength(255),
      ]),
      asyncTrue((current: string) => userChecker({ filter: compare.eq('email', current) })),
    ),
    password: new UntypedFormControl(
      null,
      Validators.compose([
        Validators.required,
        Validators.minLength(6),
      ]),
    ),
    name: new UntypedFormControl(
      null,
      Validators.required,
    ),
    phone: new UntypedFormControl(
      null,
    ),
  });
}
